import { USER_WALLET_STATE } from './constants'

const state = {
  [USER_WALLET_STATE]: {
    error: null,
    isFetching: false,
    availableCredit: [],
  },
}

export default state
